import React, { FunctionComponent, useEffect, useState } from 'react';
import { Typography, Container, Paper, CircularProgress } from '@material-ui/core';
import styles from './Common.module.scss';
import { data } from './local';
import { useHistory } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useSelector } from 'react-redux';
import { loadStaticHtmlContent } from '../services/StaticHtmlContentService';

const ThoughtStarters: FunctionComponent<any> = () => {
    const history = useHistory();
    const languageSelected: any = useSelector((state: any) => state.lang);
    const { nominationEditor } = (data as any)[languageSelected];

    const [tsHtml, setTsHtml] = useState<string>('');
    const [initialLoading, setInitialLoading] = useState<boolean>(true);  // spinner on first load
    const [translating, setTranslating] = useState<boolean>(false);       // fade while switching language
    const [loadError, setLoadError] = useState<string>('');
    const hasLoadedOnce = React.useRef<boolean>(false);

    useEffect(() => {
        let isMounted = true;
        setLoadError('');

        if (!hasLoadedOnce.current) {
            setInitialLoading(true);
        } else {
            setTranslating(true);      // fade content
        }

        loadStaticHtmlContent('thoughtstarters', languageSelected)
            .then((html: string) => {
                if (!isMounted) return;
                setTsHtml(html);
                hasLoadedOnce.current = true;
            })
            .catch((err: any) => {
                console.error('Error loading Thought Starters content:', err);
                if (isMounted) setLoadError('Unable to load Thought Starters content. Please ensure the language HTML files exist in the public/thoughtstarters folder.');
            })
            .finally(() => {
                if (isMounted) {
                    setInitialLoading(false);
                    setTranslating(false);
                }
            });

        return () => { isMounted = false; };
    }, [languageSelected]);

    return (
        <React.Fragment>
            <Container maxWidth={"xl"} className={styles.ThoughtStarters}>
                <div className={styles.BackNav}>
                    <ArrowBackIosIcon />
                    <span onClick={() => { history.go(-1); }}>{nominationEditor.back}</span>
                </div>
                <Paper>
                    {loadError ? (
                        <Typography style={{ padding: '30px', color: '#d32f2f', fontFamily: 'Barlow' }}>
                            {loadError}
                        </Typography>
                    ) : initialLoading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <div
                            className={`${styles.TSDocxContent} ${translating ? styles.docxFading : styles.docxVisible}`}
                            dangerouslySetInnerHTML={{ __html: tsHtml }}
                        />
                    )}
                </Paper>
            </Container>
        </React.Fragment>
    );
};

export default ThoughtStarters;